import { api } from 'data/api/api'
import { CreateCustomReturnShipmentArgs } from 'types/api/arguments/create-custom-return-shipment-args'

export const createCustomReturnShipment = ({
  transactionId,
  returnShippingOption,
}: CreateCustomReturnShipmentArgs) =>
  api.post(`/transactions/${transactionId}/shipment/return_shipping_option`, {
    return_shipping_option: returnShippingOption,
  })
